// Lightweight role helpers for non-event-scoped checks.
//
// For event-scoped role decisions use useEffectiveRole(eventId). These
// helpers are the simpler "is this user platform staff?" / "is this user
// an org admin somewhere?" checks that don't need an event_id.

// True when the user is M55 platform staff (any platform_role) OR has the
// legacy users.role='m55_admin' bridge.
export const isPlatformStaff = (profile) =>
  !!profile?.platform_role || profile?.role === 'm55_admin'

// True when the user has admin-tier platform power (creates orgs, manages
// platform settings, etc.). Both platform_role='admin' and the legacy
// users.role='m55_admin' qualify.
export const isPlatformAdmin = (profile) =>
  profile?.platform_role === 'admin' || profile?.role === 'm55_admin'

// True when the user can act as a GM globally OR is platform staff.
// Mirrors the old `users.role IN ('m55_admin','gm')` shortcut used by
// auth redirects and the M55 Personnel surfaces.
export const isPlatformOrGlobalGm = (profile) =>
  !!profile?.platform_role
  || profile?.role === 'm55_admin'
  || profile?.role === 'gm'
